import { forwardRef, Module } from '@nestjs/common';
import { ApplicationExceptionHandler } from '@schemax-whatsapp/backend-utils';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationController } from './application.controller';
import { ApplicationService } from './application.service';
import { Application } from '../src/app/entity/application.entity';
import { BiMessageModule } from '../src/app/bi-message/bi-message.module';
import { ModuleModule } from '../src/app/module/module.module';

@Module({
    imports: [
        TypeOrmModule.forFeature([
            Application
        ]),
        forwardRef(()=> ModuleModule),
        forwardRef(()=> BiMessageModule)
    ],
    controllers: [ApplicationController],
    providers: [ApplicationService, ApplicationExceptionHandler],
    exports: [ApplicationService]
})
export class ApplicationModule {}

